import { useState, type ChangeEvent, type FormEvent } from 'react';
import { navigate } from '../../hooks/useHashRoute';

interface SearchBoxProps {
  initialValue?: string;
  placeholder?: string;
}

function normalizeSymbol(value: string): string {
  const clean = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (!clean) return '';
  return clean.endsWith('USDT') ? clean : `${clean}USDT`;
}

export function SearchBox({ initialValue = '', placeholder = 'Search any coin, e.g. BTC or SUI' }: SearchBoxProps): React.JSX.Element {
  const [value, setValue] = useState(initialValue);
  const submit = (event: FormEvent) => {
    event.preventDefault();
    const symbol = normalizeSymbol(value);
    if (symbol) navigate(`/coin/${symbol}`);
  };

  return (
    <form className="search-box" onSubmit={submit} role="search">
      <input
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="Search coin"
        id="coin-search"
        name="coin"
        autoComplete="off"
      />
      <button type="submit" aria-label="Open coin analysis">
        ↗
      </button>
    </form>
  );
}
